module.exports = __webpack_public_path__ + "static/media/NORWAY.ed7007a8.svg";